import { Grid, Stack, Typography } from "@mui/material";
import {
  FormGetField,
  FormGetResponse,
  FormsGetResponse,
} from "../../models/Form";
import dayjs from "dayjs";
import EditButton from "../EditButton";

const ImmuneGlobulinDayList = <T extends FormsGetResponse>({
  items,
  onClick,
}: {
  items: T[];
  onClick: (day: any) => void;
}) => {
  const sortedItems = items
    ?.filter((a) => a.values.length > 0)
    .sort((a, b) => {
      const dateA = dayjs(
        (a as unknown as FormGetResponse).values.find(
          (a) => a.fieldAlias === "D_PERGamma_1_Date"
        )?.value
      ).valueOf();
      const dateB = dayjs(
        (b as unknown as FormGetResponse).values.find(
          (a) => a.fieldAlias === "D_PERGamma_1_Date"
        )?.value
      ).valueOf();
      return dateB - dateA;
    });
  return (
    <>
      {sortedItems?.map((item, index) => {
        const values = item.values as unknown as FormGetField[];
        const date = values.find(
          (a) => a.fieldAlias === "D_PERGamma_1_Date"
        )?.value;
        const drug = values.find(
          (a) => a.fieldAlias === "D_PERGamma_2_Drug"
        )?.value;
        const dose = values.find(
          (a) => a.fieldAlias === "D_PERGamma_3_Dosage"
        )?.value;
        const batch = values.find(
          (a) => a.fieldAlias === "D_PERGamma_4_Batch"
        )?.value;
        const adverseevent = values.find(
          (a) => a.fieldAlias === "D_PERGamma_5_AdverseEvent"
        )?.value;
        return (
          <Grid
            container
            key={`${date}-${index}`}
            p={2}
            sx={{ borderBottom: "1px solid lightgrey" }}
            spacing={2}
          >
            <Grid item xs={12} sm={3}>
              <Stack direction="column">
                <Typography sx={{ paddingBottom: 2 }}>
                  {date.substring(0, 10)}
                </Typography>
                <EditButton onClick={() => onClick(item)} />
              </Stack>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Stack direction="column">
                <Typography>
                  <b>Dos (ml): </b>
                  {dose}
                </Typography>
                <Typography>
                  <b>Batchnummer: </b>
                  {batch}
                </Typography>
                <Typography>
                  <b>Läkemedel: </b>
                  {drug}
                </Typography>
                <Typography>
                  <b>Biverkningar: </b>
                  {adverseevent}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        );
      })}
    </>
  );
};

export default ImmuneGlobulinDayList;
